var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isToggledRepsHistory
    ? _c(
        "div",
        [
          _vm.repetitions.length == 0
            ? _c("div", { staticClass: "reps_card" }, [_vm._m(0)])
            : _vm._l(_vm.repetitions, function(item, index) {
                return _c("div", { key: index, staticClass: "reps_card" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 font-weight-bold" }, [
                      _vm._v(
                        "\n            # " +
                          _vm._s(_vm.repetitions.length - index)
                      ),
                      _vm.subtaskId != 99999
                        ? _c("span", [
                            _vm._v(" - Rating: " + _vm._s(item.score) + " ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isMentee && _vm.parent_form == "add_reps"
                        ? _c(
                            "a",
                            {
                              staticClass: "edit-rep",
                              attrs: { href: "javascript:void(0);" },
                              on: {
                                click: function($event) {
                                  return _vm.onEditRep(item, index)
                                }
                              }
                            },
                            [_vm._v("\n                Edit\n            ")]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _vm._v(_vm._s(_vm._f("formatDate")(item.createdAt)) + " ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _vm._v("Mentor: " + _vm._s(item.mentor_name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-2" }, [
                    item.score
                      ? _c("div", { staticClass: "col-6 font-weight-bold" }, [
                          _vm._v("Comment:")
                        ])
                      : _c("div", { staticClass: "col-6 font-weight-bold" }, [
                          _vm._v(" ")
                        ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-6 text-right font-weight-bold" },
                      [_vm._v("Time on Task: ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _vm.subtaskId != 99999
                      ? _c("div", { staticClass: "col-6" }, [
                          _vm._v(_vm._s(item.comment))
                        ])
                      : _c("div", { staticClass: "col-6" }, [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _vm._v(_vm._s(_vm._f("formatHourMin")(item.timeOnTask)))
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.isMentee && _vm.parent_form == "add_reps"
                    ? _c("div", { staticClass: "row mt-2" }, [
                        _c("div", { staticClass: "col-12 font-weight-bold" }, [
                          _c(
                            "a",
                            {
                              staticClass: "delete-rep",
                              attrs: { href: "javascript:void(0);" },
                              on: {
                                click: function($event) {
                                  return _vm.onDeleteRep(item, index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    Delete\n                "
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _vm._v("No reps recorded for this task!")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4293bb10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4293bb10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/repetition_history.vue
// module id = null
// module chunks = 